import { OptionsObject } from "notistack";
import { AlertErrorProp } from "../components/SnackbarNoti";
import { HideAwaiting } from "./Awaiting";

export function errorNoti(error: any){
    if (error.response == null) {
        return {message: "UNKNOWN_ERROR", option: AlertErrorProp as OptionsObject};
    }
    console.log(error.response);
    HideAwaiting();
    if (error.response.status == 401){
        return {message: "INVALID_CREDENTIALS", option: AlertErrorProp as OptionsObject};
    }
    if (error.response.status == 404){
        return {message: "NOT_FOUND", option: AlertErrorProp as OptionsObject};
    }
    return {message: "UNKNOWN_ERROR", option: AlertErrorProp as OptionsObject}
}